import React, { useEffect, useRef } from 'react';
import GameCard from './GameCard';

function formatDateHeader(dateStr) {
  const date = new Date(dateStr + 'T00:00:00');
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);

  const eventDate = new Date(date);
  eventDate.setHours(0, 0, 0, 0);

  if (eventDate.getTime() === today.getTime()) {
    return 'Today';
  } else if (eventDate.getTime() === tomorrow.getTime()) {
    return 'Tomorrow';
  } else {
    return date.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' });
  }
}

function groupEventsByDate(events) {
  const groups = {};
  events.forEach(event => {
    // Parse commence_time and get local date
    const commence = new Date(event.commence_time);
    const dateKey = commence.toLocaleDateString('en-CA'); // YYYY-MM-DD format
    if (!groups[dateKey]) {
      groups[dateKey] = [];
    }
    groups[dateKey].push(event);
  });

  // Sort dates and return as array of [dateKey, events]
  return Object.entries(groups).sort(([a], [b]) => a.localeCompare(b));
}

function OddsGrid({ events, prevOdds, activeMarket = 'h2h', highlightedEventId, onClearHighlight, onSelectGame, evOpportunities = [], arbOpportunities = [], maxOdds = null, selectedBooks = [] }) {
  const highlightedRef = useRef(null);

  // Auto-scroll to highlighted game
  useEffect(() => {
    if (highlightedEventId && highlightedRef.current) {
      highlightedRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [highlightedEventId]);

  if (!events || events.length === 0) {
    return <div className="empty-state">No games available</div>;
  }

  const dateGroups = groupEventsByDate(events);
  let globalIndex = 0;

  return (
    <div className="odds-grid-grouped">
      {dateGroups.map(([dateKey, dateEvents]) => (
        <div key={dateKey} className="date-group">
          <div className="date-group-header">{formatDateHeader(dateKey)}</div>
          <div className="odds-grid">
            {dateEvents.map((event) => {
              const index = globalIndex++;
              return (
                <GameCard
                  key={event.id}
                  event={event}
                  prevOdds={prevOdds}
                  activeMarket={activeMarket}
                  isHighlighted={event.id === highlightedEventId}
                  highlightRef={event.id === highlightedEventId ? highlightedRef : null}
                  onClearHighlight={onClearHighlight}
                  onSelectGame={onSelectGame}
                  evOpps={evOpportunities.filter(o => o.event_id === event.id)}
                  arbOpps={arbOpportunities.filter(o => o.event_id === event.id)}
                  altFetchDelay={index * 500}
                  maxOdds={maxOdds}
                  selectedBooks={selectedBooks}
                />
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}

export default OddsGrid;
